<img id="profile-image" [class.small-size]="smallSize" [class.large-size]="largeSize" *ngIf="imageId; else profileRef" [src]="image" alt="" />
<ng-template #profileRef>
  <div id="profile-image-placeholder" [style.fontSize]="fontSize" [class.small-size]="smallSize" [class.large-size]="largeSize" [style.background]="backgroundColor">
    {{ firstName && firstName[0] | case : 'upper' : 'tr-TR' }}{{ lastName && lastName[0] | case : 'upper' }}
  </div>
</ng-template>
